import React, { useEffect, useState } from "react";
const ES1Update = ({ ...props }) => {
    const [load, setload] = useState(true)
    const [formData, setFormData] = useState({
        EmploymentId: Number(props.employmentId),
        UserId: Number(localStorage.getItem("userId")),
        ParametersId: Number(props.parametersId),
        JobseekersCol3: 0, 
        Totalnumber4: 0,
        NoOfJobseekersCol5: 0, 
        RegistrationremovedCol6: 0, 
        JobseekersremainingCol7: 0,
        SubmissionsMadeCol8: 0,
        TotalVacanciesCol9: 0,
        VacanciesFilled10: 0
        
    });


    const getdata = async () => {
        const sendData = {
            UserId: Number(localStorage.getItem("userId")),
            ParametersId: Number(props.parametersId),
            EmploymentId: Number(props.employmentId),
        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK+'api/Main/GetES1Details', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    const maindata = data[0]
                    //console.log(maindata)
                    setFormData({
                        JobseekersCol3: maindata.jobseekersCol3,
                        Totalnumber4: maindata.totalnumber4,
                        NoOfJobseekersCol5: maindata.noOfJobseekersCol5,
                        RegistrationremovedCol6: maindata.registrationremovedCol6,
                        JobseekersremainingCol7: maindata.jobseekersremainingCol7,
                        SubmissionsMadeCol8: maindata.submissionsMadeCol8,
                        TotalVacanciesCol9: maindata.totalVacanciesCol9,
                        VacanciesFilled10: maindata.vacanciesFilled10,
                        UserId: Number(localStorage.getItem("userId")),
                        ParametersId: Number(props.parametersId),
                        EmploymentId: Number(props.employmentId),
                    });
                    setload(false)
                })


    };
    const onInputChange = async (e) => {
        e.target.value < 0 ? e.target.value = null : Number(e.target.value)
        setFormData({ ...formData, [e.target.name]: Number(e.target.value), [props.setGTotal]: Number(formData.JobseekersCol3) });
        const sendData = {
            ...formData, [e.target.name]: Number(e.target.value)
        }
       /* //console.log(sendData)*/

        await fetch(process.env.REACT_APP_API_LINK+'api/Main/UpdateDetailsES1', {
            method: 'POST',
            headers: {  
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                maindata => {
                    setFormData({
                        JobseekersCol3: maindata.jobseekersCol3,
                        Totalnumber4: maindata.totalnumber4,
                        NoOfJobseekersCol5: maindata.noOfJobseekersCol5,
                        RegistrationremovedCol6: maindata.registrationremovedCol6,
                        JobseekersremainingCol7: maindata.jobseekersremainingCol7,
                        SubmissionsMadeCol8: maindata.submissionsMadeCol8,
                        TotalVacanciesCol9: maindata.totalVacanciesCol9,
                        VacanciesFilled10: maindata.vacanciesFilled10,
                        UserId: Number(localStorage.getItem("userId")),
                        ParametersId: Number(props.parametersId),
                        EmploymentId: Number(props.employmentId),
                    });
                    setload(false)
                })
        props.setGTotal(props.GTotal + 1)

    };

    




    useEffect(() => {
        getdata()
    }, [props.Change])

    const inputHandler = (e) => {
        const { value, maxLength } = e.target;
        if (String(value).length >= maxLength) {
            e.preventDefault();
            return;
        }
    };
   

    return (
        load ? null :
            
        <tr scope="row"  >
                
            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                {props.sno}

            </td>

            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 , minWidth: 200}} >
                {props.name}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                    {props.edit ? <input
                        type="number"
                        id="JobseekersCol3"
                        className="form-control"
                        name="JobseekersCol3"
                        maxLength="9"
                        min="0"
                        onKeyPress={inputHandler} 
                        style={{ textAlign: 'center' }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.JobseekersCol3}
                    /> : formData.JobseekersCol3}
                

            </td>
            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 200 }} >
                    {props.edit ? <input
                        type="number"
                        id="Totalnumber4"
                        className="form-control"
                        name="Totalnumber4"
                        maxLength="7"
                        min="0"
                        onKeyPress={inputHandler} 
                      style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Totalnumber4}
                    /> : formData.Totalnumber4}

            </td>
            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                    {props.edit ?
                        <input
                            type="number"
                            min="0"
                            id="NoOfJobseekersCol5"
                            className="form-control"
                            name="NoOfJobseekersCol5"
                            maxLength="7"
                            onKeyPress={inputHandler}
                          style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                            onChange={(e) => onInputChange(e)}
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            defaultValue={formData.NoOfJobseekersCol5}
                        /> : formData.NoOfJobseekersCol5}


            </td>
            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 300 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="RegistrationremovedCol6"
                        className="form-control"
                        name="RegistrationremovedCol6"
                        maxLength="7"
                        onKeyPress={inputHandler}
                      style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.RegistrationremovedCol6}
                    /> : formData.RegistrationremovedCol6}

            </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                    <label> {formData.JobseekersremainingCol7}</label>
            </td>
            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ?
                        <input
                            type="number"
                            min="0"
                            id="SubmissionsMadeCol8"
                            className="form-control"
                            name="SubmissionsMadeCol8"
                            maxLength="7"
                            onKeyPress={inputHandler}
                          style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                            onChange={(e) => onInputChange(e)}
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            defaultValue={formData.SubmissionsMadeCol8}
                        /> : formData.SubmissionsMadeCol8}

            </td>       <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ?
                        <input
                            type="number"
                            min="0"
                            id="TotalVacanciesCol9"
                            className="form-control"
                            name="TotalVacanciesCol9"
                            maxLength="7"
                            onKeyPress={inputHandler}
                          style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                            onChange={(e) => onInputChange(e)}
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            defaultValue={formData.TotalVacanciesCol9}
                        /> : formData.TotalVacanciesCol9}

            </td>                                          <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ?
                        <input
                            type="number"
                            min="0"
                            id="VacanciesFilled10"
                            className="form-control"
                            name="VacanciesFilled10"
                            maxLength="7"
                            onKeyPress={inputHandler}
                          style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                            onChange={(e) => onInputChange(e)}
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            defaultValue={formData.VacanciesFilled10}
                        /> : formData.VacanciesFilled10}

            </td>

        </tr>
    );
};

export default ES1Update;
